<template>
  <div>
    <div class="contents" ref="imageWrapper1">
      <span class="titles">续当凭证</span>
      <div class="headers">
        <div class="headers_lefts">
          <div>注意背面</div>
          <div>续当须知</div>
        </div>
        <div class="header_right">
          <div>广东省地方金融监督管理局监制</div>
          <div>
            NO：44

            <input type="number" class="headers_numbers" placeholder="点击输入续当票号" v-model="xpiao"/>
          </div>
        </div>
      </div>

      <div>
        <!-- {{ UpdateData.stas }}
      {{ UpdateData.ticketnumber }} -->

        <table width="100%">
          <tr>
            <td width="20%">典当行名称</td>
            <td>
              <span class="pris">{{ $store.state.name }}</span>
            </td>
            <td width="20%">原当票号</td>
            <td>
              <span class="pris">{{ UpdateData.ticketnumber }}</span>
            </td>
          </tr>
          <tr>
            <td>当户名称</td>
            <td>
              <span class="pris">{{ UpdateData.name }}</span>
            </td>
            <td>联系人</td>
            <td>
              <span class="pris">{{ UpdateData.name }}</span>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              原典当金额（大写）<span class="pris">{{ DXpri }}</span>
            </td>

            <!-- {{
            util.digitUppercase(10000)
          }} -->
            <!-- <td></td> -->
            <td colspan="2">
              小写金额 ￥ <span class="pris">{{ UpdateData.pri + ".00" }}</span>
            </td>
            <!-- <td></td> -->
          </tr>
          <tr>
            <td colspan="2">
              续当综合费用（大写）<span class="pris">{{ DXzhf }}</span>
            </td>
            <!-- <td></td> -->
            <td colspan="2">
              小写金额 ￥ <span class="pris">{{ UpdateData.xupri }}</span>
            </td>
            <!-- <td></td> -->
          </tr>
          <tr>
            <td colspan="2">
              当户应付上期利息（大写）<span class="pris">{{ DXlx }}</span>
            </td>
            <!-- <td></td> -->
            <td colspan="2">
              小写金额 ￥ <span class="pris">{{ UpdateData.lx }}</span>
            </td>
            <!-- <td></td> -->
          </tr>
          <tr>
            <td colspan="2">
              当户总计交付金额（大写）<span class="pris">{{ DXsum }}</span>
            </td>
            <!-- <td></td> -->
            <td colspan="2">
              小写金额 ￥ <span class="pris">{{ Number(UpdateData.xupri) + Number(UpdateData.lx) }}</span>
            </td>
            <!-- <td></td> -->
          </tr>
        </table>
        <table width="100%">
          <tr>
            <td colspan="3">
              <span>续当期限：</span> 由 <span class="dats"> {{ StateYear }}</span> 年
              <span class="dats">{{ StateMonth }} </span>月
              <span class="dats">{{ StateDay }} </span>日 起 至
              <span class="dats">{{ EndYear }} </span>年
              <span class="dats">{{ EndMonth }} </span>月
              <span class="dats">{{ EndDay }} </span>日
            </td>
          </tr>
          <tr>
            <td width="20%">
              月费率
              <span><input type="number" class="inp" v-model="yfl">%</span>
              <!-- <span class="pris">{{ (UpdateData.xupri / UpdateData.pri) * 100 }} %</span> -->
            </td>
            <td rowspan="2">当户签章</td>
            <td rowspan="2" height="55" width="45%">
           
              <div class="qz_content">
                <div>典当行签章</div>
                <div class="qz_text">
                   <span>逾期续当/赎当须按月费率4.2%结付本当期综合费且本当期典当利息不减免；</span>
                <span>逾期不足5天按5天收取。此为电子续费回单，以实际《续当凭证》为准。</span>
                </div>
               
                </div>
              <!-- <div class="imgs">
                <img :src="$store.state.image" alt="" />
              </div> -->
            </td>
          </tr>
          <tr>
            <td>月利率 <span >
              <input type="number" v-model="yll" class="inp">%
              </span></td>
          </tr>
        </table>

        <div class="dates">
          <span>复核：{{ UpdateData.review }}</span>
          <span>经办：{{ UpdateData.agent }}</span>
          <span>保管：</span>
          <span>制单时间：</span>
          <span>{{ MakeYear }} 年</span>
          <span>{{ MakeMonth }} 月</span>
          <span>{{ MakeDay }} 日</span>
        </div>
      </div>
    </div>
    <div>
      <el-button type="text" @click="createImg">本地保存</el-button>
      <el-button type="text" @click="createPz">一键上传</el-button>
    </div>
  </div>
</template>
<script>
import util from "@/components/util";
import dayjs from "dayjs";
 import html2canvas from "html2canvas";
 const COS = require("cos-js-sdk-v5");
const cos = new COS({
  SecretId: "AKID1pOghRu62i7G8j36sOddMoztXv2tUord", // 身份识别ID
  SecretKey: "YjdHfndCUVGjwta091cwzmIXVBbkcEag", // 身份秘钥
});
export default {
  name: "Voucher",
  props: ["UpdateData"],
  data() {
    return {
      info: "",
      DXpri: "", //大写典当金额
      DXzhf: "", //大写综合费
      DXlx: "", //大写利息
      DXsum: "", //大写总计交付金额
      xpiao:"", //续当票号

      StateYear: dayjs(this.UpdateData.overdate).format("YYYY"), //开始年份
      StateMonth: dayjs(this.UpdateData.overdate).format("MM"), //开始月份
      StateDay: dayjs(this.UpdateData.overdate).format("DD"), //开始日期

      EndYear: dayjs(this.UpdateData.enddate).format("YYYY"), //结束年份
      EndMonth: dayjs(this.UpdateData.enddate).format("MM"), //结束月份
      EndDay: dayjs(this.UpdateData.enddate).format("DD"), //结束日期

      MakeYear: dayjs(this.UpdateData.xuday).format("YYYY"), //制单日期
      MakeMonth: dayjs(this.UpdateData.xuday).format("MM"), //制单月份
      MakeDay: dayjs(this.UpdateData.xuday).format("DD"), //制单日期

      yfl:0, //月费率 
      yll:0, //月利率


    };
  },
  methods: {
    createPz() {
      html2canvas(this.$refs.imageWrapper1).then((canvas) => {
        let dataURL = canvas.toDataURL("image/png");
        // console.log(dataURL);
        if (dataURL !== "") {
          // this.upload(dataURL,dayjs().format("YYYYMMDDHHmmss")+Math.random()+".png")
          // var img = dataURL;
          // var alink = document.createElement("a");
          // alink.href = img;
          // alink.download = "downloadName.png";
          // alink.click();
        let newImgUrl =   this.dataURLtoFile(dataURL,dayjs().format("YYYYMMDDHHmmss")+Math.random()+".png")
        this.upload(newImgUrl,newImgUrl.name)
        }
      });
    },
    //将base64文件转换成图片文件
    dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while(n--){
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, {type:mime});
  },
     createImg() {
      html2canvas(this.$refs.imageWrapper1).then((canvas) => {
        let dataURL = canvas.toDataURL("image/png");
        // console.log(dataURL);
        if (dataURL !== "") {
          var img = dataURL;
          var alink = document.createElement("a");
          alink.href = img;
          alink.download = dayjs().format("YYYYMMDDHHmmss")+Math.random()+".png";
          alink.click();
        }
      });
    },

    //   //element 上传方法
    upload(imgData,ImgName) {
      if (imgData) {
        // 执行上传操作
        cos.putObject(
          {
            Bucket: "changan-1259114000" /* 存储桶 */,
            Region: "ap-guangzhou" /* 存储桶所在地域，必须字段 */,
            Key:ImgName /* 文件名 */,
            StorageClass: "STANDARD", // 上传模式, 标准模式
            Body: imgData, // 上传文件对象
           
          },
          (err, data) => {
            // 上传成功之后
            if (data.statusCode == 200) {
              // this.Imgs.push("https://" + data.Location);
             
              let ImgUrl = "https://" + data.Location
              // this.uploadtype = false;
              this.UploadImgInfo(ImgUrl)
            }
          }
        );
      }
    },
    //上传到服务器
    UploadImgInfo(ImgUrl){
      //上传数据
       this.axios.post("/api/tcb/databaseadd?access_token=" + this.ACCESS_TOKEN, {
                  env: `${this.userData.env}`,
                  query:`db.collection("voucher").add({data:{createDate:"${dayjs().format("YYYY-MM-DD HH:mm:ss")}",ticketnumber:"${this.UpdateData.ticketnumber}",xpiao:"${this.xpiao}",name:"${this.UpdateData.name}",stateDate:"${this.UpdateData.overdate}",endDate:"${this.UpdateData.enddate}",imgUrl:"${ImgUrl}",yfl:"${this.yfl}",yll:"${this.yll}"}})`

    }).then(res=>{
      if(res.data.errcode==0){
         this.$notify({
          title: '凭证上传成功',
          message: '业务凭证已上传至服务器',
          type: 'success'
        });
      }
    })
  }
  },
  created() {
      //获取到this.ACCESS_TOKEN
    this.getTokens();

    //获取当前登录的用户数据
    this.getUserToken();
  },
  mounted() {
    this.DXpri = util.digitUppercase(this.UpdateData.pri);
    this.DXzhf = util.digitUppercase(this.UpdateData.xupri);
    this.DXlx = util.digitUppercase(this.UpdateData.lx);
    this.DXsum = util.digitUppercase(this.UpdateData.xupri + this.UpdateData.lx);
  },
};
</script>
<style scoped>
table {
  border-collapse: collapse;
}
td {
  /* height: 35px; */
  border: 1px solid black;
  font-size: 16px;
  /* text-align: center; */
}
.titles {
  display: flex;
  flex-direction: row;
  justify-content: center;
  font-size: 20px;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  font-weight: bold;
}
.headers {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 10px;
}
.headers_lefts {
  font-size: 18px;
  width: 80px;
  height: 50px;
  border: 2px solid #000000;
  text-align: center;
}
.header_right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  font-size: 18px;
}
.headers_numbers {
  color: brown;
  border: none;
  font-size: 19px;
}
.dates {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.contents {
  padding: 20px 20px;
  margin: 0 auto;
  width: 90%;
  height: 90%;
}
.pris {
  margin-left: 20px;
}
.dats {
  margin: 0 20px;
}
.imgs {
  /* position: absolute;
  bottom: 28%;
  right: 15%; */
}
.imgs img {
  width: 75px;
  height: 75px;
}
.PrintPZ {
  margin: 50px 0;
}
.qz_text{
  width: 400px;
  height: 100%;
  border: 1px solid red;
  margin:0 20px;
}
.qz_text span{
  color: red;
}
.qz_content{
  display: flex;
  flex-direction: row;
}
.inp{
  width:50%;
  height: 100%;
  border: none;
  font-size: 15px;
}
</style>
